<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 條件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="姓名" prop="realName">
                <a-input v-model="queryParam.realName" placeholder="請輸入姓名" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="身份證" prop="idCard">
                <a-input v-model="queryParam.idCard" placeholder="請輸入身份證" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="暱稱" prop="userName">
                <a-input v-model="queryParam.userName" placeholder="請輸入暱稱" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查詢</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />

      <!-- 增加詳情 -->
      <detail-form
        ref="detailForm"
        @ok="getList"
      />

      <!-- 數據展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>

        <img style="width: 48px;height: 48px;" preview="人像面" :src="record.portraitPlane" v-if="record.portraitPlane != null && record.portraitPlane != ''" slot="portraitPlane" slot-scope="text, record">

        <img style="width: 48px;height: 48px;" preview="封面" :src="record.emblemPlane" v-if="record.emblemPlane != null && record.emblemPlane != ''" slot="emblemPlane" slot-scope="text, record">

        <span slot="operation" slot-scope="text, record">
           <a @click="$refs.detailForm.handleUpdate(record, undefined)" v-if="record.isSociety == 1">
            公會詳情
          </a>
          <a-divider type="vertical"/>
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-if="record.applicationStatus == 0">
            審核
          </a>
        </span>
      </a-table>
      <!-- 分頁 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 條`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageUserCertification,listUserCertification, delUserCertification } from '@/api/platform/userCertification'
import CreateForm from './modules/CreateForm'
import DetailForm from './modules/DetailForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'UserCertification',
  components: {
    CreateForm,
    DetailForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高級搜索 展開/關閉
      advanced: false,
      // 非單個禁用
      single: true,
      // 非多個禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查詢參數
      queryParam: {
        realName: null,
        idCard: null,
        portraitPlane: null,
        emblemPlane: null,
        isSociety: null,
        guildLicense: null,
        settlementAccount: null,
        accountName: null,
        branchName: null,
        branchAdress: null,
        userId: null,
        refusalCause: null,
        applicationStatus: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '暱稱',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '姓名',
          dataIndex: 'realName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '身份證',
          dataIndex: 'idCard',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '人像面',
          dataIndex: 'portraitPlane',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: "portraitPlane"}
        },
        {
          title: '國徽面',
          dataIndex: 'emblemPlane',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: "emblemPlane"}
        },
        {
          title: '是否存在公會',
          dataIndex: 'isSociety',
          ellipsis: true,
          align: 'center',
          customRender: function (value) {
            if (value == 0){
              return "否"
            }
            if (value == 1){
              return "是"
            }
          }
        },
        {
          title: '申請狀態',
          dataIndex: 'applicationStatus',
          ellipsis: true,
          align: 'center',
          customRender: function (value) {
            if (value == 0){
              return "審核中"
            }
            if (value == 1){
              return "已同意"
            }
            if (value == 2){
              return "已拒絕"
            }
          }
        },
        {
          title: '拒絕原因',
          dataIndex: 'refusalCause',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查詢用戶-實名認證（主播認證）列表 */
    getList () {
      this.loading = true
     pageUserCertification(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按鈕操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按鈕操作 */
    resetQuery () {
      this.queryParam = {
        realName: undefined,
        idCard: undefined,
        portraitPlane: undefined,
        emblemPlane: undefined,
        isSociety: undefined,
        guildLicense: undefined,
        settlementAccount: undefined,
        accountName: undefined,
        branchName: undefined,
        branchAdress: undefined,
        userId: undefined,
        refusalCause: undefined,
        applicationStatus: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 刪除按鈕操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '確認刪除所選中數據?',
        content: '當前選中編號為' + ids + '的數據',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delUserCertification(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '刪除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空刪除ids列表
          that.ids = []
        }
      })
    },
    /** 導出按鈕操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否確認導出?',
        content: '此操作將導出當前條件下所有數據而非選中數據',
        onOk () {
          that.download('platform/user-certification/export', {
            ...that.queryParam
          }, `用戶-實名認證（主播認證）_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
